import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { ErrorMessage, SalesPortalCheckoutRequest, SalesPortalCheckoutResponse } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalCheckoutProps {
  gym: string;
  packageId: string;
  billingPlanId: string;
}

function useSalesPortalCheckout({
  gym,
  packageId,
  billingPlanId,
}: IUseSalesPortalCheckoutProps): UseMutationResult<
  AxiosResponse<SalesPortalCheckoutResponse>,
  AxiosError<ErrorMessage>,
  SalesPortalCheckoutRequest
> {
  const salesPortalCheckout = (
    request: SalesPortalCheckoutRequest,
  ): Promise<AxiosResponse<SalesPortalCheckoutResponse>> => {
    return client.post(
      `sales-portal/gyms/${gym}/packages/${packageId}/billing-plans/${billingPlanId}/checkout/`,
      request,
    );
  };

  return useMutation(salesPortalCheckout);
}

export default useSalesPortalCheckout;
